import {
  MarketplaceInstallationsDocument,
  MarketplaceInstallationsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetMarketplaceInstallations = (
  variables: MarketplaceInstallationsQueryVariables
) => {
  const { loading, data, refetch } = useQuery(MarketplaceInstallationsDocument, { variables })
  const installationsData = data?.marketplace.companyInstallationsConnection.nodes ?? []

  return {
    loading,
    data: installationsData,
    refetch,
  }
}
